import React, { useState, FC } from 'react';
import QueryValuesLayout from 'src/components/Layouts/QueryValuesLayout';
import LoadingScreen from 'src/frontend-common/components/LoadingScreen';
import { FrontendLookupsProps, LookupTab, NavigateCallbackFn } from 'src/frontend-common/dto/Interfaces/FrontendLookups';
import { useParams } from 'react-router-dom';
import { useGetActiveCompanyName } from 'src/hooks/useGetActiveCompanyName';
import ErrorBoundary from 'src/frontend-common/components/MicroServiceErrorBundary';
import { productsTableStructure } from 'src/frontend-common/dto/Interfaces/FrontendLookups/LookupsTableStructure/utilsProducts';
import { useSelector } from 'react-redux';
import { selectUser } from 'src/redux/slices/userSlice';
import { isAdmin } from 'src/utils/user';

const Lookups: FC<{ navigateTo: NavigateCallbackFn }> = ({ navigateTo }) => {
  const [activeTab, setActiveProduct] = useState<LookupTab>(productsTableStructure[0] as LookupTab);
  const FrontendLookups: FC<FrontendLookupsProps> = React.lazy(() => import('FrontendLookups/FrontendLookups'));
  const activeCompany = useGetActiveCompanyName();
  const activeTabParam = useParams<{ activeTab?: string }>();
  const user = useSelector(selectUser);

  return (
    <ErrorBoundary>
      <React.Suspense fallback={<LoadingScreen variant="circle" />}>
        <QueryValuesLayout>
          {({ limit, setLimit, page, setPage, sort, setSort, dateRange, setDateRange, token, setToken }) => (
            <FrontendLookups
              limit={limit}
              setLimit={setLimit}
              token={token}
              setToken={setToken}
              sort={sort}
              setSort={setSort}
              page={page}
              setPage={setPage}
              dateRange={dateRange}
              setDateRange={setDateRange}
              scoreFilterVisible={activeTab.name !== 'all'}
              productFilter={activeTab.name === 'digital score' || activeTab.name === 'onboarding' || activeTab.name === 'login' ? 'score' : activeTab.name}
              filteredTableStructure={activeTab.structure}
              setActiveProduct={setActiveProduct}
              scoreFilterFromMemoryHook={undefined}
              activeTabParam={activeTabParam}
              activeCompany={activeCompany}
              isUserAdmin={isAdmin(user)}
              navigateTo={navigateTo}
            />
          )}
        </QueryValuesLayout>
      </React.Suspense>
    </ErrorBoundary>
  );
};
export default Lookups;
